export default class RequestFactory {

    constructor() {
        this.request = {
            basketorder : {
                inpost : {
                    paczkomat_primary : {
                        name : null,
                        postcode : null,
                        street : null,
                        buildingnumber : null,
                        town : null,
                        latitude : null,
                        longitude : null,
                        paymentavailable : null,
                        operatinghours : null,
                        locationdescription : null,
                        paymentpointdescr : null,
                        paymenttype : null
                    },
                    iemail : null,
                    itelefon : null,
                    chk_inpost_accept : null
                },
                pos : {
                    pos_id : null
                },
                policies : {
                    aimor : false,
                    discount : false,
                    newsletter : false
                },
                discount: {
                    discountCode: '',
                    discountId: ''
                }
            },
            agreements : {
                accountControllAgreement : false,
                rodoControllAgreement : false,
                promotionControllAgreement : false
            }
        };
    }

    addByJqueryObject(object) {
        return this.addHtmlField(object.prop('name'), object.val());
    }

    addHtmlField(fieldName,fieldValue) {
        let result = [...fieldName.match(/[a-z\_]+/gi)];

        this.addField(result,fieldValue);
    }

    addField(array, value) {
        let currentState = this.request;

        for(let i=0; i< array.length; i++) {

            if(currentState[array[i]] == undefined) {
                currentState[array[i]] = {};
            }
            currentState = currentState[array[i]];
        }

        if(array.length == 3) {
            this.request[array[0]][array[1]][array[2]] = value;
        }
        if(array.length == 2) {
            this.request[array[0]][array[1]] = value;
        }
        if(array.length == 1) {
            this.request[array[0]] = value;
        }
    }

    addInpostData(deliveryComponent, additionalData = null) {
        this.request.basketorder.inpost.paczkomat_primary = deliveryComponent;

        if(additionalData) {
            let dd = Object.entries(additionalData);

            dd.map(entry => {
                this.request.basketorder.inpost[entry[0]] = entry[1];
            });
        }
    }

    addPosdata(posData) {
        this.request.basketorder.pos = posData.pos;
    }

    addPaymentInfo(paymentComponent) {

    }

    addDiscount(data) {
        this.request.basketorder.discount.discountCode = data.discoundCode;
        this.request.basketorder.discount.discountId = data.discoundId;
    }
}
